import styled from '@emotion/styled'
import { Box, Typography } from '@mui/material'
import { exportToPPT_tableCss } from '../../../../util'
import { MEDIA } from '../../../../constants'
import { lightTheme } from '../../../../theme'
import { MuiButton } from '../../../../components'

export const RootWrap = styled(Box)(
  (props) => `
    display: flex;
    flex-direction: column;
    // padding: 20px 30px 50px 30px;
    width: 100%;
    min-height: 50vh;
    position : relative;

    /*
    &.stickyCompetitiveLandscape.freezed {
        padding-top: 65px;
    }
    &.stickyCompetitiveLandscape.freezed .pptListHeader {
        position: fixed;
        top: 60px;
        background: #fff;
        width: calc(100% - 257px);
        left: auto;
        z-index: 1;
    }
    &.stickyCompetitiveLandscape.hasInsights .pptListHeader {
        width: calc(100% - 558px);
    }
    */


    &.exportToPPT {padding:0; min-height: 650px;}
    &.exportToPPT .list p{ font-size:14px !important; line-height:15px !important;}
    &.exportToPPT .list p label{ width:100%;} // Mozilla FIX
    
    &.exportToPPT .pptListWrapper {
        padding: 0;
        padding-right:10px;
        & > div {
            padding: 0;
            margin: 0;
        }
        & .listHeading {
            padding: 5px 0;
        }
        & .list > div {
            margin: 0 5px;
            padding: 7.5px 5px;
        }
        & img {
            max-width:90%;
        }
    }
    ${exportToPPT_tableCss}

    @media (max-width: ${MEDIA.lg}) {
        padding:20px 20px 40px 20px;
    }
`
)

export const TableWrap = styled(Box)(`
    display: flex;
    flex-wrap: wrap;
    // border-bottom: 1.5px solid #E7E7E7;
    width: 100%;
    overflow-x:auto; // this is used for horizontal scroll
    flex-direction:row;
    overflow:unset; // this is used  for sticky header
`)

export const StyledCellWrap = styled(Box)(`
    min-width:100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: auto;
    width : 100%;
    // border-bottom: 0.7px solid #E7E7E7;
    // border-top: 1.5px solid #E7E7E7;
    border-left: 1.5px solid #E7E7E7;
    margin-top : 12px;

    &.list-collapsed {
      border-left : none;
    }

    &.list:first-of-type {
      .barBlock {
        margin-left : 0;
      }
    }

    & img {
        height:15px;
        max-width:100%;
    }
`)

export const StyledTypography = styled(Typography)(
  (props) => `
    padding: ${props?.background ? '2px' : 0} 0 !important;
    font-size: 12px;
    line-height: 12px;
    font-weight: 300;
    width:100%;
    display:flex;
    justify-content:space-between;
    align-items:center;
    color: ${props.fontcolor};
    position: relative;
    background: ${props?.background ? "url('data:image/gif;base64,R0lGODlhBQAEAIcAAPv8/s7P0fX2+Pj5+9zd397g4QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQEAgAAACwAAAAABQAEAAAIEgABCBxIIECAAgAGCBAwYKDAgAA7') repeat-x 50%" : 'none'};

    ${
      props?.background &&
      `
        &:after{
            content: '';
            background-color: red;
            height: auto;
            min-height: 15px;
            width: inherit;
            display:none;
        }`
    }

    & label {
        background: #fff;
        display: inline-block;
        padding-right: 5px;
        max-width : calc(100% - 25px);
    }

    & span {
        background: #fff;
        position: absolute;
        right: 3px;
    }

    & svg {
      position : relative;
      top : 1px;
      min-width : 11px;
    }

    &.toolTipItem {
      justify-content : flex-start;
      gap : 6px;
      font-size : 13px;
      align-items : baseline;
      padding : 0 8px 0 11px !important;
      line-height : 20px;
      font-weight : 500;
      // svg {
      //   left : 1px;
      // }

      span {
        position : initial;
 
        svg {
          top : -1px;
        }
      }
    }
`
)

export const ShadowWrap = styled('div')(
  (props) => `
    background: #FFFFFF;
    border-bottom: ${`2px solid ${props.leftBorderColor}`};
    margin: ${props.isSentiment ? '0 12px 0' : '0'};
    display: flex;
    // box-shadow: ${props.isSentiment ? '0px 0px 6px rgba(0, 0, 0, 0.15)' : ''};
    height: 100%;
    // margin: ${props.isSentiment && !props.isLastColumn ? '0 10px' : !props.isSentiment ? '0' : '0 0 0 10px'};
    // min-height: 100px;
    display: flex;
    flex-direction: column;
    justify-content: normal;
    position : relative;
    border-radius : 2px;
    padding-bottom : 2px;

    &::before {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 30px;
      background: linear-gradient(to top, ${props.leftBorderColor}, transparent);
      opacity: 0.05;
      z-index: 0;
      pointer-events: none; 
    }

    & .textItemShadow {
        // padding-right:15px !important;
        font-size:  ${props.isSentiment ? '12px' : '14px'};
        line-height:  ${props.isSentiment ? '14px' : '18px'};
        align-items : baseline;
        justify-content : left;
        margin-bottom : 8px;
        gap : 3px;
    }

    & .textItemShadow label {
        overflow-wrap: anywhere !important;
        line-height: 16px;
        font-weight: 500;
        max-width : calc(100% - 25px);
    }
`
)

export const LegendWrap = styled(Box)(`
    margin-top: 30px;
    margin-left: auto;
`)

export const ListHeaderWrapper = styled(Box)(`
    width: 100%;
    max-width : 100%;
    display: flex;
    background: #fff;
    position: sticky;
    top: 0;
    z-index: 5;
    // box-shadow : 0px 5px 10px rgba(0,0,0,0.05);

      &.sliderOn {
      display: block;

      .slick-slide:focus,
      .slick-slide:focus-visible,
      .slick-slide *:focus {
        outline: none;
      }

      .slick-slide {
        &:first-of-type {
          .listHeading {
            margin-left : 0;
          }
        }
        &:last-child {
          .listHeading {
            margin-right : 0;
          }
        }
      }

      & .listHeading {
        width: calc(100% - 16px) !important;
        display : flex !important;
      }
    }

    &.sliderOff {
      .listHeading:first-of-type {
        margin-left: 0;
        border-left: none;

        >div {
          margin-left: 0;
        }
      }

      .listHeading:last-child {
        margin-right: 0;

        >div {
          margin-right: 0;
        }
      }

      .listHeading {
        display: flex;
      }

    }
`)

export const ListDetailsWrapper = styled(Box)(`
    width: 100%;
    display: flex;
    flex-direction: column;

    &.sliderOn {
    display : block;

      .slick-slide:focus,
      .slick-slide:focus-visible,
      .slick-slide *:focus {
        outline: none;
      }
    }

    &.sliderOff .content-wrapper .list{
      &:first-of-type {
        border-left: none;

        >div {
          margin-left: 0;
        }
      }

      &:last-child {
        >div {
          margin-right: 0;
        }
      }
  }
`)

export const RowTitleHeading = styled(Box)(`
  width: 100%;
  display: flex;
  // justify-content: space-between;
  justify-content: flex-start;
  gap : 8px;
  margin-bottom: 8px;
  margin-top : 28px; 

  &.row-head-wrap {
    margin-top : 16px;
    margin-left : 2px;
  }

  & .MuiTypography-root {
    font-size : 14px;
    line-height : 20px;
  }

  & .row-percentage {
    font-weight : 600;
  }
`)

export const RowHeadingWrapper = styled(Box)(`
  width: 100%;
  display: flex;
  align-items : center;
  cursor : pointer;

  .dynamicTourText {
    span {
      padding-top : 15px !important;
    }
  }

  &:hover {
    color : rgba(9, 91, 189, 1);

    svg path {
      fill : rgba(9, 91, 189, 1);
    }

    .dynamicTourText {
      svg path {
        fill : white;
      }
    }
  }

  & .row-head {
    width: 100%;
    position : relative;
  }
`)

export const RowHeadingContent = styled(Box)(`
  width: 100%;
  display: flex;
  position: relative;

  .dynamicTourText {
      span {
        padding-top : 7px !important;
      }
  }
`)

export const ProgressBarWrapper = styled('div')(`
  height: 4px;
  background-color: #E5E7EB; // Lighter gray to match Figma
  width: 100%; // Changed from 100px to 100%
  border-radius: 2px;
  overflow: hidden;
  position: relative;
`)

export const ProgressBar = styled('div')(
  (props) => `
  width: ${props.width || 0}%; 
  height: 100%;
  background-color: ${lightTheme.palette.primary.main || '#0047AB'};
  transition: width 0.3s ease-in-out;
  border-radius: 2px; 
`)

export const ArrowIconWrapper = styled('span')(`
  margin : 17px 0 0 17px;
  cursor : pointer;
  position : relative;
`)

export const IconUpWrap = styled(`span`)(`
    path {
      fill : rgba(9, 91, 189, 1);
    }
`)

export const SliderWrapper = styled(Box)(
  (props) => `
  width : 100%;
  max-width : 100%;
  overflow: hidden; 
  
  .slick-list {
    // width : ${props.isFullScreen || props.mdScreen ? 'calc(100vw - 89px)' : 'calc(100vw - 315px)'};
    width : ${props.slideWrapperWidth || 'calc(100vw - 315px)'};
    max-width : 100%;

    .slick-track {
        height: auto;
        display: flex;

        .slick-slide {
          height: auto;

          >div {
            height: 100%;

            .list {
              height: calc(100% - 15px);
            }
          }
        }
      }
  }

  & .slick-slider {
    .slick-track .slick-slide {          
      &:first-of-type {     
        .list , .listHeading {
          border-left : none;
          
          > div {
            margin-left : 0;
          }
        }
      }
          
      &:last-child {
      .list , .listHeading {
          > div {
            margin-right : 0;
          }
        }
      }

    }
  }
`)

export const ArrowButtons = styled(MuiButton)(`
  position : absolute;
  display : flex !important;
  padding : 25px 14px !important;
  min-width : unset;
  z-index : 5;
  top : 60%;
  background : rgba(204, 204, 204, 1);
  svg {
    fill : rgba(104, 104, 103, 1);
  }
  
  &:focus {  
    background : rgba(204, 204, 204, 1);
    svg {
      fill : rgba(104, 104, 103, 1);
    }
  }
  
  &:hover {
    background : rgba(69, 69, 69, 1);
    svg {
      fill : rgba(255, 255, 255, 1);
    }
  }
  
  &:active {
    background : rgba(42, 42, 41, 1);
    svg {
      fill : rgba(255, 255, 255, 1) !important;
    }
  }
    
  &.slick-disabled {
    background : rgba(246, 246, 245, 1);
    svg {
      fill : rgba(202, 208, 213, 1);
    }
  }

  &:before {
    content : '';
  }

  &.slick-prev {
    left : 0
  }

  &.slick-next {
    right : 0px;
  } 
`)

export const BarContainer = styled('div')`
  display: flex;
  gap: 8px;
  position : relative;
`;

export const BarBlock = styled('div')(({barColor}) => `
  width: 100%;
  height: 14px;
  border-radius: 4px;
  border: 1px solid rgba(173, 173, 172, 1);
  background-color: ${barColor};
  margin : 0 6px;
`);

export const ToolTipContainer = styled('div')`
  position : absolute;
  display: flex;
  top : 30px;
  flex-direction: column;
  z-index: 1;
  background: #fff;
  box-shadow: 0px 5px 12px 0px rgba(0, 0, 0, 0.18);
  width : 100%;
  border-radius : 4px;

  &:before {
    content: "";
    position: absolute;
    top: -9px;
    left: 50%;
    transform: translateX(-50%) rotate(45deg);
    width: 18px;
    height: 18px;
    background: #efefef;
    z-index: -1;
  }
`;

export const CellContainer = styled('div')(props => `
  display: flex;
  gap: 8px;
  flex-direction: ${props.direction};
  padding-top: 12px;
`);

export const TooltipRowName = styled('span')(props => `
  background : ${props.titleBackgroundColor};
  border : ${props.titleBackgroundColor == 'transparent' ? '1px solid #efefef' : ''};
  padding: 8px 8px 6px;
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
`);

export const TooltipColName = styled('span')`
  background : rgba(239, 239, 239, 1);
  padding: 8px 8px 6px;
  font-size: 14px;
  line-height: 16px;
  font-weight: 500;
  border-top-right-radius : 4px;
  border-top-left-radius: 4px;
`;